/* "Soraya personalisation" block: drop-downs for stones / letters / engravings / children + preview. */
(function () {
  if (customElements.get('smr-perso')) return;
  var STATE = window.__smrPerso || (window.__smrPerso = {});

  function radios(fid, pos) {
    return [].filter.call(document.querySelectorAll('input[type="radio"]'), function (r) {
      return r.name.indexOf(fid) === 0 && new RegExp('option' + pos + '$').test(r.name);
    });
  }
  function checkedIndex(fid, pos) {
    var i = 0;
    radios(fid, pos).forEach(function (r, j) { if (r.checked) i = j + 1; });
    return i;
  }
  function labelOf(r) {
    var l = document.querySelector('label[for="' + r.id + '"]');
    return l ? l.textContent.trim() : r.value;
  }
  function pickRadio(fid, pos, idx) {
    var r = radios(fid, pos)[idx - 1];
    if (!r) return;
    r.click();
    if (!r.checked) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
  }

  class SmrPerso extends HTMLElement {
    connectedCallback() {
      if (this._on) return;
      this._on = true;
      var d = this.dataset;
      this.fid = d.form;
      this.cpos = +d.countPos || 0;
      this.mpos = +d.metalPos || 0;
      this.st = STATE[this.id] || (STATE[this.id] = {});
      this.kids = d.kids ? d.kids.split(',').map(function (p) { return p.split(':').map(Number); }) : null;
      this.bind();
      var self = this;
      this._sync = function () { setTimeout(function () { self.apply(); }, 30); };
      document.addEventListener('variant:change', this._sync);
      document.addEventListener('change', this._sync);
      this._submit = function (e) { self.validate(e); };
      document.addEventListener('click', this._submit, true);
      this._out = function (e) { if (!self.contains(e.target)) self.closeAll(); };
      document.addEventListener('click', this._out);
      this.apply();
    }
    hideNative() {
      // The block's drop-down replaces the native buttons of the "quantity" option.
      if (!this.cpos) return;
      radios(this.fid, this.cpos).forEach(function (r) {
        var f = r.closest('.variant-picker__option');
        if (f) f.style.display = 'none';
      });
    }
    disconnectedCallback() {
      this._on = false;
      document.removeEventListener('variant:change', this._sync);
      document.removeEventListener('change', this._sync);
      document.removeEventListener('click', this._submit, true);
      document.removeEventListener('click', this._out);
    }
    count() {
      var rows = this.querySelectorAll('.smp-row').length;
      if (!this.cpos) return rows;
      var idx = checkedIndex(this.fid, this.cpos);
      if (this.kids) { var k = this.kids[idx - 1]; return k ? k[0] + k[1] : 0; }
      var r = radios(this.fid, this.cpos)[idx - 1];
      var n = r ? parseInt(labelOf(r), 10) : NaN;
      return isNaN(n) ? rows : n;
    }
    bind() {
      var self = this;
      var cnt = this.querySelector('.smp-count');
      if (cnt) cnt.addEventListener('change', function () { pickRadio(self.fid, self.cpos, +cnt.value); self.apply(); });
      this.querySelectorAll('[data-kid]').forEach(function (s) {
        s.addEventListener('change', function () {
          var g = +self.querySelector('[data-kid="g"]').value, f = +self.querySelector('[data-kid="f"]').value;
          var idx = 0;
          self.kids.forEach(function (k, j) { if (k[0] === g && k[1] === f) idx = j + 1; });
          self.st.kids = [g, f];
          self.querySelector('.smp-kerr').hidden = !!idx;
          if (idx) pickRadio(self.fid, self.cpos, idx);
          self.apply();
        });
      });
      this.querySelectorAll('.smp-ddb').forEach(function (b) {
        b.addEventListener('click', function () {
          var dd = b.parentNode, open = !dd.classList.contains('open');
          self.closeAll();
          dd.classList.toggle('open', open);
          dd.querySelector('.smp-ddl').hidden = !open;
        });
      });
      this.querySelectorAll('.smp-ddl li').forEach(function (li) {
        li.addEventListener('click', function () {
          var dd = li.closest('.smp-dd'), h = dd.querySelector('input');
          h.value = li.dataset.v;
          self.st[h.name] = h.value;
          self.closeAll();
          self.clearMiss(li.closest('.smp-row'));
          self.apply();
        });
      });
      this.querySelectorAll('.smp-row select, .smp-row input[type=text]').forEach(function (i) {
        i.addEventListener('input', function () {
          self.st[i.name] = i.value;
          var c = i.parentNode.querySelector('.smp-cnt');
          if (c) c.textContent = i.value.length + '/' + i.maxLength;
          if (i.value) self.clearMiss(i.closest('.smp-row'));
          if (i.tagName === 'SELECT') self.apply();
        });
      });
      this.addEventListener('keydown', function (e) { if (e.key === 'Escape') self.closeAll(); });
    }
    closeAll() {
      this.querySelectorAll('.smp-dd.open').forEach(function (d) { d.classList.remove('open'); d.querySelector('.smp-ddl').hidden = true; });
    }
    clearMiss(row) {
      if (row) row.classList.remove('miss');
      if (!this.querySelector('.smp-row.miss')) { var c = this.querySelector('.smp-perso'); if (c) c.classList.remove('has-err'); }
    }
    apply() {
      this.hideNative();
      var self = this, n = this.count(), d = this.dataset;
      var cnt = this.querySelector('.smp-count');
      if (cnt) { var ci = checkedIndex(this.fid, this.cpos); if (ci) cnt.value = String(ci); }
      if (this.kids) {
        var ki = checkedIndex(this.fid, this.cpos), k = this.kids[ki - 1];
        if (k && !this.st.kids) this.st.kids = k;
        var cur = this.st.kids || k;
        if (cur) { this.querySelector('[data-kid="g"]').value = cur[0]; this.querySelector('[data-kid="f"]').value = cur[1]; }
      }
      this.querySelectorAll('.smp-row').forEach(function (r) {
        var i = +r.dataset.i, on = i <= n, last = i === n;
        r.hidden = !on;
        var lab = last ? r.dataset.ll : r.dataset.l;
        if (n > 1 && i === 1 && d.fs) lab += ' ' + d.fs;
        if (n > 1 && last && d.ls) lab += ' ' + d.ls;
        r.querySelector('.smp-lab').textContent = lab;
        r.querySelectorAll('input, select').forEach(function (inp) {
          inp.disabled = !on;
          if (self.st[inp.name] != null && inp.value !== self.st[inp.name]) inp.value = self.st[inp.name];
        });
        var dd = r.querySelector('.smp-dd');
        if (dd) self.paint(dd);
      });
      this.preview(n);
    }
    paint(dd) {
      var h = dd.querySelector('input'), b = dd.querySelector('.smp-ddb'), sel = null;
      dd.querySelectorAll('li').forEach(function (x) { var on = x.dataset.v === h.value; x.classList.toggle('on', on); if (on) sel = x; });
      b.innerHTML = sel ? '<img src="' + sel.dataset.img + '" alt="" width="32" height="32"><span>' + sel.dataset.t + '</span>'
                        : '<span class="ph">' + (this.dataset.ph || '') + '</span>';
      dd.dataset.k = sel ? sel.dataset.k : '';
    }
    metal() {
      var keys = (this.dataset.metalKeys || '').split(',').map(function (s) { return s.trim(); });
      var i = this.mpos ? checkedIndex(this.fid, this.mpos) : 1;
      return keys[(i || 1) - 1] || keys[0] || '';
    }
    preview(n) {
      var p = this.querySelector('.smp-prev');
      if (!p) return;
      var pd = p.dataset, files = this.dataset.files, inner = p.querySelector('.smp-prev-in'), base = p.querySelector('.smp-base');
      var src = files + pd.base.replace('[metal]', this.metal()).replace('[n]', n);
      if (base.getAttribute('src') !== src) base.src = src;
      inner.querySelectorAll('.smp-it').forEach(function (e) { e.remove(); });
      var keys = [];
      if (this.kids) {
        var k = this.st.kids || [0, 0], g;
        for (g = 0; g < k[0]; g++) keys.push('garcon');
        for (g = 0; g < k[1]; g++) keys.push('fille');
      } else {
        this.querySelectorAll('.smp-row:not([hidden]) .smp-dd').forEach(function (dd) { keys.push(dd.dataset.k || pd.default); });
      }
      if (!pd.item || !keys.length) return;
      var size = +pd.size || 9, gap = +pd.gap || 12, y = +pd.y || 50, n2 = keys.length;
      (pd.geo || '').split(';').forEach(function (part) {
        var kv = part.split('='), r, v;
        if (kv.length < 2) return;
        r = kv[0].split('-');
        if (n2 >= +r[0] && n2 <= +(r[1] || r[0])) {
          v = kv[1].split(',').map(Number);
          gap = v[0] || gap; y = v[1] || y; size = v[2] || size;
        }
      });
      keys.forEach(function (key, j) {
        var c = [50 + (j - (n2 - 1) / 2) * gap, y];
        var s = size;
        var im = document.createElement('img');
        im.className = 'smp-it';
        im.alt = '';
        im.src = files + pd.item.replace('[k]', key).replace('[metal]', this.metal());
        im.style.left = c[0] + '%';
        im.style.top = c[1] + '%';
        im.style.width = im.style.height = s + '%';
        inner.appendChild(im);
      }, this);
    }
    validate(e) {
      var s = e.target.closest && e.target.closest('button[type="submit"],[name="add"]');
      if (!s) return;
      var f = s.form || s.closest('form');
      if (!f || f.getAttribute('id') !== this.fid) return;
      this.apply();
      var miss = [];
      this.querySelectorAll('.smp-row:not([hidden])').forEach(function (r) {
        var i = r.querySelector('input:not([type=radio]), select');
        if (i && !i.value.trim()) { miss.push(r); r.classList.add('miss'); }
      });
      var kerr = this.querySelector('.smp-kerr');
      if (miss.length || (kerr && !kerr.hidden)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var c = this.querySelector('.smp-perso');
        if (c && miss.length) c.classList.add('has-err');
        (miss[0] || kerr).scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  }
  customElements.define('smr-perso', SmrPerso);
})();
